import React, { Component,Row } from 'react';
import Slider from 'react-slick';
import { subscribe } from 'react-contextual';
import RenderByDeviceType from '../../../../common/renderByDeviceType';
import onClickHandle from '../onClickHandle';
// import CovidModal from '../../modal/covidModal';


class CarouselPanel extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const { items } = this.props;
		const sliderSettings = {
			arrows: true,
			dots: true,
			infinite: true,
			speed: 500,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
		};

		const slides = items.map((item, index) => {

			const mobileStartUtm = item.mobile_link && item.mobile_link.indexOf('?utm_source') - 1;
			const desktopStartUtm = item.desktop_link && item.desktop_link.indexOf('?utm_source') - 1;
			const linkStartUtm = item.link && item.link.indexOf('?utm_source') - 1;

			const mobile_link = (mobileStartUtm > -1 ? item.mobile_link.substring(0, mobileStartUtm) : item.mobile_link) || (linkStartUtm > -1 ? item.link.substring(0, linkStartUtm) : item.link)
			const desktop_link = (desktopStartUtm > -1 ? item.desktop_link.substring(0, desktopStartUtm) : item.desktop_link) || (linkStartUtm > -1 ? item.link.substring(0, linkStartUtm) : item.link)
			const mobile = (
				<a href={mobile_link} onClick={
					(e) => onClickHandle(e, 'carousel click', { link: JSON.stringify(mobile_link), name: item.altText}, mobile_link)

					}>
					{this.props.AB && this.props.AB.varients && this.props.AB.varients['homepage'] === 'a' ? 
					<img className="pointer w-100" src={item.src.mobile} alt={item.altText} loading="lazy"/> : 
					<img className="pointer w-100" src={item.src.mobile} alt={item.altText} loading="lazy"/>
					}
				</a>
			);

			const desktop = (
				
				<a href={desktop_link} onClick={(e) => onClickHandle(e, 'carousel click', { link: JSON.stringify(desktop_link), name: item.altText }, desktop_link)}>
					{this.props.AB && this.props.AB.varients && this.props.AB.varients['homepage'] === 'a' ? 
					<img className="pointer w-100" src={item.src.desktop} alt={item.altText} loading='lazy'/> : 
					<img className="pointer w-100" src={item.src.desktop} alt={item.altText} loading='lazy'/> }	
				</a>
			);

			return (
				<div key={index}>
					<RenderByDeviceType mobile={mobile} desktop={desktop} />
				</div>
			)
		});

		return (
			<React.Fragment>
				<div className="d-flex w-100 home-paeg-carousel-arrow justify-content-center homepage-carousel">
					<Slider {...sliderSettings}>
						{slides}
					</Slider>
				</div>
				{/* <CovidModal /> */}
				<style global jsx>
					{
						`
						.homepage-carousel .slick-slider {
							width: 100%;
						}
  
						.homepage-carousel .pointer {
							cursor: pointer;
						}

						.homepage-carousel .slick-dots {
							bottom: 20px;
						}

						.homepage-carousel .slick-dots li button:before {
							font-size: 3rem;
						}

						.slick-next {
							right: 25px;
						}

						.slick-prev {
							left: 25px;
						}
						// .home-paeg-carousel-arrow .slick-slider {
						// 	padding: 0 25px;
						// }
						
						.home-paeg-carousel-arrow .slick-next,
						.home-paeg-carousel-arrow .slick-prev {
							
							background-repeat: no-repeat;
							height: 80px;
						}
						
						.home-paeg-carousel-arrow .slick-next {
							right: 2rem;							
							background-image: url('https://give-marketplace.s3.ap-south-1.amazonaws.com/static/icons/program-page/right-arrow.svg');
						}
						
						.home-paeg-carousel-arrow .slick-prev {
							left: 2rem;
							z-index: 1!important;
							background-image: url('https://give-marketplace.s3.ap-south-1.amazonaws.com/static/icons/program-page/left-arrow.svg');
						}
						
						.home-paeg-carousel-arrow .slick-prev.slick-disabled,
						.home-paeg-carousel-arrow .slick-next.slick-disabled {
							background-image: none;
						}
						
						.home-paeg-carousel-arrow .slick-next:before {
							content: '';
							color: black;
						}
						
						.home-paeg-carousel-arrow .slick-prev:before {
							content: '';
							color: black;
						}
						@media (max-width: 768px) {
							.home-paeg-carousel-arrow .slick-next {
							   display: none!important;                         
							} 
							.home-paeg-carousel-arrow .slick-prev {
								display: none!important;                         
							 }                       
						}
						`
					}
				</style>
			</React.Fragment>
		);
	}
}


export default subscribe()(CarouselPanel);
